import {
  and,
  collection,
  getDocs,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Failure from '../../../core/Failure';
import Notifications from '../../models/Notifications';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function getContactNotifications(contact: IContact): Promise<Notifications[] | null> {
  try {
    const db = firestore;
    const notificationsCollection = collection(db, FirestoreCollections.notifications);

    const notificationsDocRef = await getDocs(
      query(
        notificationsCollection,
        and(
          where('id_contact', '==', contact.id),
          where('id_api_key', '==', contact.id_api_key)
        ),
        orderBy('updated', 'asc')
      )
    );

    const notifications: Notifications[] = [];
    notificationsDocRef.docs.forEach((doc) => {
      notifications.push(doc.data() as Notifications);
    });

    return notifications;
  } catch (e) {
    console.log('error: ', e);
    throw new GetContactNotificationsFailure();
  }
}

export class GetContactNotificationsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getContactNotifications;
